import './new.note.list.detail.scss';

import { Avatar, Box, Divider } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import { NotesListDetailData } from '@converge/graphql';
import { Stack } from '@mui/system';
import { marked } from 'marked';
import moment from 'moment';

marked.setOptions({
  gfm: true, // Enable GitHub Flavored Markdown features including strikethrough
});
export interface INewNoteDetailProps {
  note: NotesListDetailData;
}

export const NewNoteListDetail = ({
  note: {
    createdAt,
    user: {
      node: { username, firstName, lastName },
    },
    note,
  },
}: INewNoteDetailProps) => {
  const renderedMarkdown = marked(note ?? 'N/A');
  const [expanded, setExpanded] = useState(false);

  const [isOverflowing, setIsOverflowing] = useState(false);
  const noteRef = useRef<HTMLDivElement>(null);
  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    const checkOverflow = () => {
      if (noteRef.current) {
        setIsOverflowing(
          noteRef.current.scrollHeight > noteRef.current.clientHeight
        );
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [renderedMarkdown]);

  return (
    <Stack className="note-list-detail">
      <Stack className="card-container">
        <div className="typography-style">
          <Box className="node-avatar">
            <Avatar className="avatar-icon">
              {username?.slice(0, 2).toUpperCase()}
            </Avatar>
          </Box>
          <Box className="userName">
            {firstName} {lastName}
          </Box>
          <Box className="create-time">
            {moment(createdAt).format('MM/DD/YYYY h:mm A')}
          </Box>
        </div>
        <Divider />
      </Stack>

      <Stack className="note">
        <div
          ref={noteRef}
          className={`rendered-note ${expanded ? 'expanded' : ''}`}
          dangerouslySetInnerHTML={{
            __html: renderedMarkdown,
          }}
        />
        {isOverflowing && (
          <button onClick={toggleExpand} className="toggle-button">
            {expanded ? <Box>LESS</Box> : <Box>MORE</Box>}
          </button>
        )}
      </Stack>
    </Stack>
  );
};
